export const dictionary = {
  main_page_title: 'Meet ELD Timer.',
  main_page_subtitle: 'One tool for reporting work hours and create reports!',
  main_page_list_item_title1: 'Sign in. ',
  main_page_list_item1: 'Select yourself from the list of users.',
  main_page_list_item_title2: 'Create log. ',
  main_page_list_item2: 'Select the appropriate parameters, click save and the entry will appear in the table.',
  main_page_list_item_title3: 'Edit log. ',
  main_page_list_item3: 'If you make a mistake, you can easily edit the log!',
  main_page_list_item_title4: 'Create a report. ',
  main_page_list_item4:
    'With just one click and selecting the time period and country, you can easily create a LAZ report.',
  sign_in: 'Sign in',
  your_timesheet: 'Your timesheet',
  copyright: 'Copyright © E-Learning Department ' + new Date().getFullYear(),
  login_access: 'Access',
  login_access_user: 'User name:',
  login_access_password: 'Password:',
  login_access_password_enter: 'Enter password',
  login_access_btn: 'Get access',
  login_title: 'Login as:',
  login_search_placeholder: 'Search user...',
  login_btn: 'Log in',
  toast_summary_success: 'Success!',
  toast_summary_warn: 'Warning',
  toast_login_detail: 'Successfully logged as ',
  toast_create_log_detail:
    'You are trying to add an entry on an unscheduled day. Plan your day with Work Planner first.',
  toast_access: 'Access granted.',
  content_hello: 'Hello ',
  content_tools: 'Tools:',
  admin_panel_btn: 'Admin Panel',
  admin_hours_fiscal_title: 'Hours for the fiscal year ',
  admin_hours_eld: 'Total reported hours ELD',
  admin_hours_esp: 'Total reported hours ESP',
  admin_chart_label_eld: 'Hours ELD',
  admin_chart_label_esp: 'Hours ESP',
  create_log_hour_report: 'Hour Report:',
  eld_btn_label: 'ELD',
  int_btn_label: 'INT',
  countries_btn_label: 'Countries',
  esp_btn_label: 'ESP',
  log_btn_label: 'Logistics',
  other_btn_label: 'Other',
  dialog_overlay_info: 'Would you like to add an entry for this date?',
  dialog_overlay_btn_label: 'Yes',
  dialog_label_date: 'Date:',
  dialog_label_wpl: 'Work place:',
  dialog_label_module: 'Module:',
  dialog_placeholder_module: 'Select module',
  dialog_error_module: 'Module is required.',
  dialog_label_version: 'Version:',
  dialog_error_version: 'Version is required.',
  dialog_placeholder_version: 'Select version',
  dialog_label_stage: 'Stage:',
  dialog_placeholder_stage: 'Select stage',
  dialog_error_stage: 'Stage is required.',
  dialog_label_task: 'Task:',
  dialog_placeholder_task: 'Select task',
  dialog_placeholder_task_write: 'Write a task',
  dialog_error_task: 'Task is required.',
  dialog_label_esp: 'ESP:',
  dialog_placeholder_esp: 'Select ESP (external companies)',
  dialog_error_esp: 'ESP is required.',
  dialog_label_country: 'Country:',
  dialog_placeholder_country: 'Select country',
  dialog_label_lang: 'Language:',
  dialog_placeholder_lang: 'Select language',
  dialog_error_lang: 'Language is required.',
  dialog_error_country: 'Country is required.',
  dialog_label_issue: 'Issue:',
  dialog_placeholder_issue: 'Select issue',
  dialog_error_issue: 'Issue is required.',
  dialog_label_module_types: 'Module types:',
  dialog_placeholder_module_types: 'Select Module Type',
  dialog_error_module_types: 'Module type is required.',
  dialog_error_client: 'Client is required.',
  dialog_label_hours: 'Hours:',
  dialog_placeholder_hours: 'Select time',
  dialog_placeholder_wpl: 'Select work place',
  dialog_error_hours: 'Time is required.',
  dialog_error_wpl: 'Work place is required.',
  dialog_label_comment: 'Comment:',
  dialog_placeholder_comment: 'Add comment',
  dialog_error_comment: 'Enter the name of the task in the comment when adding Minor Projects.',
  dialog_save_btn: 'Save',
  dialog_update_btn: 'Update',
  dialog_button_label1: 'Ftf_2.0',
  dialog_button_label2: 'MA_3.0',
  dialog_button_label3: 'Nuggets',
  dialog_button_label4: 'Other',
  dialog_button_label5: 'Localization management',
  dialog_button_label6: 'Clear the ESP field',
  dialog_button_label7: 'FtF',
  dialog_button_label8: 'Logistic',
  dialog_button_label9: 'MA',
  dialog_button_label10: 'MA_2.0',
  dialog_button_label11: 'Nugget AUDI',
  dialog_button_label12: 'Nugget INT',
  dialog_button_label13: 'Hour management',
  dialog_button_label14: 'Localization',
  dialog_button_label15: 'Development',
  dialog_button_label20: 'BL/AL',
  dialog_button_label21: 'PODCASTS',
  dialog_button_label22: 'VIDEO',
  eld_dialog_header: 'ELD time report',
  int_dialog_header: 'INT time report',
  country_dialog_header: 'Country time report',
  log_dialog_header: 'Logistics time report',
  other_dialog_header: 'Other time report',
  esp_dialog_header: 'ESP time report',
  esp_dialog_invoice_export: 'FV Report',
  esp_dialog_invoice_filtered_tab: 'Filtered Table',
  esp_dialog_invoice_filtered_fv: 'FILTERED INVOICES',
  esp_dialog_invoice_header: 'Invoice Manager',
  esp_dialog_invoice_conversion: 'Conversion rate PLN -> EUR',
  esp_dialog_invoice_start_stage: 'Start stage',
  esp_dialog_invoice_cost_net: 'ESP cost net',
  esp_dialog_invoice_cost_gross: 'ESP cost gross',
  esp_dialog_invoice_cost_net_eur: 'ESP cost net EUR',
  esp_dialog_invoice_cost_gross_eur: 'ESP cost gross EUR',
  esp_dialog_invoice_cost_prc_eur: 'ELD cost 10% EUR',
  esp_dialog_invoice_cost_total: 'Total costs',
  esp_dialog_balance_to_pay: 'Balance to Pay:',
  esp_dialog_balance_to_pay_info: '(ESP cost net - Net paid 1 Invoice) not editable',
  esp_dialog_invoice_inv_net_paid_1: 'Net paid 1 Invoice',
  esp_dialog_invoice_inv_net_paid_2: 'Net paid 2 Invoice',
  esp_dialog_invoice_inv_date1: 'Date of registration 1',
  esp_dialog_invoice_inv_date2: 'Date of registration 2',
  esp_dialog_invoice_inv_net_paid__eur_1: 'Net paid EUR 1 Invoice',
  esp_dialog_invoice_inv_net_paid_eur_2: 'Net paid EUR 2 Invoice',
  esp_dialog_invoice_inv_gross_paid_1: 'Gross paid 1 Invoice',
  esp_dialog_invoice_inv_gross_paid_2: 'Gross paid 2 Invoice',
  esp_dialog_invoice_inv_gross_paid__eur_1: 'Gross paid EUR 1 Invoice',
  esp_dialog_invoice_inv_gross_paid_eur_2: 'Gross paid EUR 2 Invoice',
  esp_dialog_invoice_net_paid: 'Net paid',
  esp_dialog_invoice_net_paid_eur: 'Net paid EUR',
  esp_dialog_invoice_gross_paid: 'Gross paid',
  esp_dialog_invoice_gross_paid_eur: 'Gross paid EUR',
  esp_dialog_invoice_net_payable: 'Net payable/ Net to be paid',
  esp_dialog_invoice_net_payable_eur: 'Net EUR payable/ Net to be paid EUR',
  esp_dialog_invoice_gross_payable: 'Gross payable/ Gross to be paid',
  esp_dialog_invoice_gross_payable_eur: 'Gross EUR payable/ Gross to be paid EUR',
  esp_dialog_invoice_nr_before: 'Invoice number before work start - 1 payment confirmed',
  esp_dialog_invoice_one_confirmed: '1 payment confirmed',
  esp_dialog_invoice_nr_after: 'Invoice number after work completion - 2 payment confirmed',
  esp_dialog_invoice_two_confirmed: '2 payment confirmed',
  esp_dialog_invoice_completion: 'Month and year of completion',
  esp_dialog_invoice_stages: 'Module Stages:',
  esp_dialog_invoice_withdrawn: 'Withdrawn',
  esp_dialog_invoice_completed: 'Save Invoice',
  esp_dialog_invoice_comments: 'Comments',
  esp_dialog_invoice_default: 'value',
  esp_dialog_invoice_error: 'This field is required.',
  esp_dialog_invoice_toast_detail: 'Data saved!',
  esp_dialog_invoice_save_success: 'Invoice updated successfully',
  esp_dialog_invoice_nr_placeholder: 'Enter invoice number',
  esp_dialog_invoice_check_status: 'Invoice status:',
  esp_dialog_invoice_check_incomplete: 'Invoice incomplete',
  esp_dialog_invoice_check_inprogress: 'Invoice in-progress',
  esp_dialog_invoice_check_complete: 'Invoice complete',
  esp_dialog_invoice_check_withdrawn: 'Withdrawn',
  esp_report_pos_name: 'ITEM NAME',
  esp_report_value: 'VALUE',
  esp_report_desc_comm: 'DESCRIPTION / COMMENT',
  esp_report_header: 'ESP Invoice Report Generator',
  esp_report_display_gj: 'Display GJ:',
  esp_report_select_gj: 'Select GJ',
  esp_report_desc_1: 'All paid invoices for GJ {gj}.',
  esp_report_desc_2: 'Net sum for modules in the current table view and brutto.',
  esp_report_desc_3: 'Net sum of all scheduled costs in the current view.',
  esp_report_desc_4: 'Gross sum of all scheduled costs in the current view.',
  esp_report_desc_5: 'Payable amount in GJ {gj}.',
  esp_report_desc_6: 'Average net price from filtered data.',
  esp_report_desc_7: 'Average net price of modules in GJ {gj}.',
  esp_report_desc_8: 'Average currency exchange rate in the current view.',
  esp_report_desc_9: 'Stage breakdown (table filters).',
  esp_report_desc_10: 'Stage breakdown in GJ {gj}.',
  esp_report_desc_11: 'Number of Complete modules (current view).',
  esp_report_desc_12: 'Number of Complete modules (GJ {gj}).',
  esp_report_desc_13: 'Number of Withdrawn modules (current view).',
  esp_report_desc_14: 'Number of Withdrawn modules (GJ {gj}).',
  esp_report_desc_15: 'Number of modules per ESP company.',
  esp_report_desc_16: 'Number of modules per country.',
  esp_report_desc_17: 'Total paid sum per ESP.',
  esp_report_desc_18: 'Amounts payable to ESPs.',
  esp_report_desc_19: 'Modules with only one paid invoice (all years).',
  esp_report_desc_20: 'In-progress status.',
  esp_report_desc_21: 'Countries assigned to ESPs.',
  esp_report_desc_22: 'Breakdown by module type.',
  esp_report_desc_23: 'Breakdown by module name.',
  esp_report_desc_24: 'Number of modules in the Sign Off stage from March in current GJ.',
  esp_report_desc_25: 'Number of invoices with complete status.',
  esp_report_close: 'Close',
  esp_report_export: 'Export to Google Sheets',
  esp_report_empty: 'Loading report data...',
  esp_report_item_1: 'TOTAL COSTS FOR CURRENT GJ',
  esp_report_item_2: 'TOTAL COSTS',
  esp_report_item_3: 'NETTO COSTS',
  esp_report_item_4: 'BRUTTO COSTS',
  esp_report_item_5: 'TOTAL AMOUNT OF COSTS TO BE PAID',
  esp_report_item_6: 'AVERAGE PRICE PER MODULE',
  esp_report_item_7: 'AVERAGE PRICE PER MODULE IN CURRENT GJ',
  esp_report_item_8: 'AVERAGE EURO PRICE',
  esp_report_item_9: 'NUMBER OF MODULES PER STAGE',
  esp_report_item_10: 'NUMBER OF MODULES PER STAGE IN CURRENT GJ',
  esp_report_item_11: 'NUMBER OF COMPLETED MODULES',
  esp_report_item_12: 'NUMBER OF COMPLETED MODULES IN CURRENT GJ',
  esp_report_item_13: 'NUMBER OF WITHDRAWN MODULES',
  esp_report_item_14: 'NUMBER OF WITHDRAWN MODULES IN CURRENT GJ',
  esp_report_item_15: 'NUMBER OF MODULES IN ESP',
  esp_report_item_16: 'NUMBER OF MODULES IN COUNTRIES',
  esp_report_item_17: 'ESP COST',
  esp_report_item_18: 'AMOUNT OF COSTS TO BE PAID BY ESP',
  esp_report_item_19: 'NUMBER OF MODULES WITH FIRST INVOICE PAID BY GJ',
  esp_report_item_20: 'NUMBER OF OPEN MODULES',
  esp_report_item_21: 'NUMBER OF COUNTRIES IN THE ESP',
  esp_report_item_22: 'NUMBER OF MODULE TYPES',
  esp_report_item_23: 'NUMBER OF MODULES',
  esp_report_item_24: 'NUMBER OF SIGN OFF MODULES IN ELD AND ESP',
  esp_report_item_25: 'NUMBER OF COMPLETED ESP INVOICES',
  esp_filtered_dialog_title: 'Filtered Results Analysis',
  esp_filtered_tab_summary: 'Summary Metrics',
  esp_filtered_tab_records: 'Filtered Records',
  esp_filtered_export_btn: 'Export Table to Google Sheets',
  esp_filtered_col_gj: 'GJ',
  esp_filtered_col_esp: 'ESP',
  esp_filtered_col_country: 'Country',
  esp_filtered_col_lang: 'Language',
  esp_filtered_col_module: 'Module',
  esp_filtered_col_version: 'Version',
  esp_filtered_col_total_hours: 'Total Hours',
  esp_filtered_col_cost_gross_eur: 'ESP Cost Gross EUR',
  esp_filtered_col_net_paid_1: 'Net paid 1 Invoice',
  esp_filtered_col_date_1: 'Date 1',
  esp_filtered_col_net_paid_eur_1: 'Net paid EUR 1 Invoice',
  esp_filtered_col_gross_paid_1: 'Gross paid 1 Invoice',
  esp_filtered_col_gross_paid_eur_1: 'Gross paid EUR 1 Invoice',
  esp_filtered_col_inv_num_1: 'Invoice number before work start',
  esp_filtered_col_pay_conf_1: '1 payment confirmed',
  esp_filtered_col_net_paid_2: 'Net paid 2 Invoice',
  esp_filtered_col_date_2: 'Date 2',
  esp_filtered_col_net_paid_eur_2: 'Net paid EUR 2 Invoice',
  esp_filtered_col_gross_paid_2: 'Gross paid 2 Invoice',
  esp_filtered_col_gross_paid_eur_2: 'Gross paid EUR 2 Invoice',
  esp_filtered_col_inv_num_2: 'Invoice number after work completion',
  esp_filtered_col_pay_conf_2: '2 payment confirmed',
  esp_filtered_col_net_paid: 'Net paid',
  esp_filtered_col_net_paid_eur: 'Net paid EUR',
  esp_filtered_col_gross_paid: 'Gross paid',
  esp_filtered_col_gross_paid_eur: 'Gross paid EUR',
  esp_filtered_col_net_payable: 'Net payable/ Net to be paid',
  esp_filtered_col_net_payable_eur: 'Net EUR payable/ Net to be paid EUR',
  esp_filtered_col_gross_payable: 'Gross payable/ Gross to be paid',
  esp_filtered_col_gross_payable_eur: 'Gross EUR payable/ Gross to be paid EUR',
  esp_filtered_col_inv_status: 'Invoice Status',
  esp_filtered_col_comments: 'Comments',
  esp_filtered_col_comp_date: 'Month and year of completion',
  esp_filtered_col_module_group: 'Module Group',
  esp_filtered_col_start_stage: 'Starting Stage',
  esp_filtered_col_module_stage: 'Module Stage',
  esp_filtered_col_euro: 'Euro Rate',
  esp_filtered_col_cost_net: 'ESP Cost Net',
  esp_filtered_col_cost_gross: 'ESP Cost Gross',
  esp_filtered_col_cost_net_eur: 'ESP Cost Net EUR',
  esp_filtered_col_eld_cost_eur: 'ELD Cost 10% EUR',
  esp_filtered_col_total_cost_eur: 'Total Cost EUR',
  esp_filtered_metric_paid_in: 'Paid in GJ {gj}',
  esp_filtered_metric_payable_in: 'Net Payable GJ {gj}',
  esp_filtered_metric_modules_in: 'Modules in GJ {gj}',
  esp_filtered_metric_total_modules: 'Total Modules (All Years)',
  esp_filtered_metric_lifetime: 'Total Lifetime Paid',
  esp_filtered_metric_desc_1: 'Sum of payments booked in fiscal year GJ {gj}',
  esp_filtered_metric_desc_2: 'Amount remaining to be paid for modules assigned to GJ {gj}',
  esp_filtered_metric_desc_3: 'Number of modules assigned to fiscal year GJ {gj}',
  esp_filtered_metric_desc_4: 'Total number of modules across all years for current filters',
  esp_filtered_metric_desc_5: 'Sum of all historical and current payments for these modules',
  work_planner_btn: 'Work Planner',
  work_planner_header: 'Work planner',
  work_planner_calendar_label: 'Select working days by clicking on the calendar:',
  work_planner_form_hours: 'Working hours:',
  work_planner_form_hours_start: 'Start hours',
  work_planner_form_hours_end: 'End hours',
  work_planner_form_work: 'Work from:',
  work_planner_form_placeholder_work: 'Select work place',
  work_planner_form_proj: 'Activity:',
  work_planner_form_placeholder_proj: 'Select activity',
  work_planner_form_other: 'Other:',
  work_planner_form_placeholder_other: 'Select absence',
  work_planner_form_submmit: 'OK',
  work_planner_preview_title: 'Schedule preview:',
  work_planner_preview_info: '(Selected days will appear below).',
  work_planner_preview_table_th1: 'Day',
  work_planner_preview_table_th2: 'Working hours',
  work_planner_preview_table_th3: 'Work place',
  work_planner_preview_table_th4: 'Activity',
  export_btn: 'Export data',
  export_dialog_exp_btn: 'Export XLS file',
  export_filename_sum: '_summary',
  export_header: 'Export data',
  export_dialog_subtitle1: 'Create an hourly report for:',
  export_dialog_subtitle2: 'Other reports:',
  export_btn_label1: 'ELD',
  export_btn_label2: 'INT Sales',
  export_btn_label3: 'INT Logistics',
  export_btn_label4: 'Country Sales',
  export_btn_label5: 'Country Logistic',
  export_btn_label6: 'Productivity',
  export_btn_label7: 'Productivity teams',
  export_btn_label8: 'Perso report',
  export_dialog_checkbox_modules: 'Select all modules',
  export_dialog_checkbox_month: 'Create a report for the selected month',
  export_dialog_preview_btn: 'Preview',
  export_dialog_calendar_placeholder: 'Select date range',
  export_dialog_raport_title: ' Report',
  export_dialog_from: 'From: ',
  export_dialog_to: 'to: ',
  export_table_th_hours: 'Hours',
  export_table_th_costs: 'Costs ',
  export_table_th_loc: 'Localization',
  export_table_th_dev: 'Development',
  export_table_summary: 'SUM',
  export_table_task_missing: 'Missing task name!',
  export_table_minor_proj_int: 'INT_Minor_projects (till 09.2024)',
  export_table_minor_proj_country: 'Minor_projects (till 09.2024)',
  export_calendar_year: 'Select year: ',
  export_calendar_from: 'From:',
  export_calendar_to: 'To:',
  productivity_table_th1: 'Task',
  productivity_table_th2: 'Internal order number',
  productivity_table_th3: 'SUM',
  productivity_table_th4: 'INT',
  productivity_table_th5: 'INT Betrieb',
  productivity_table_summary_overview: 'Summary Overview',
  productivity_table_summary_sales_hours: 'Summary Hours sales',
  productivity_table_summary_log_hours: 'Summary Hours logistics',
  productivity_table_summary_esp_sales: 'External Service Providers sales',
  productivity_table_summary_esp_log: 'External Service Providers logistics',
  productivity_table_summary_int_empl_hours: 'INT employees hours',
  productivity_table_summary_sales_sum: 'Sales sum',
  productivity_table_summary_log_sum: 'Logistics sum',
  productivity_table_summary_country_sum: 'Country sum',
  productivity_table_summary_proportion: 'Proporcion',
  productivity_table_summary_cost_sales: 'Costs sales (+10%)',
  productivity_table_summary_cost_log: 'Costs logistics (+10%)',
  productivity_table_summary_bill: 'Bill for country (total)',
  productivity_table_resources: 'Resources',
  productivity_table_management: 'Management: 10%',
  productivity_table_management_trainings: 'Management: 10% + Trainings',
  productivity_table_wpl: 'Working days HO/Office without ESP:',
  productivity_table_wpl_ho_hours: 'Home Office hours',
  productivity_table_wpl_office_hours: 'Office hours',
  productivity_table_wpl_total: 'Total (+ overtime)',
  productivity_teams_btn_qct: 'QC team Sum',
  productivity_teams_btn_indet: 'Content team Sum',
  productivity_teams_btn_devt: 'Development team Sum',
  productivity_teams_btn_loct: 'Localization team Sum',
  productivity_teams_year: ' Productivity Report for the Year ',
  productivity_teams_no_data: 'No data',
  productivity_teams_no_data_info: 'No data to display for the selected year.',
  productivity_teams_jobs_info:
    'You can edit the number of current employee positions in the RCP Data (Full-time jobs) table.',
  productivity_teams_loc_support: 'Localization support',
  productivity_teams_table_row_header: 'Month',
  productivity_teams_table_row_label1: 'Localization management',
  productivity_teams_table_row_label2: 'INT',
  productivity_teams_table_row_label_sharepoint: 'Sharepoint INT',
  productivity_teams_table_row_label3: 'Logistics',
  productivity_teams_table_row_label4: 'ELD - internal tasks',
  productivity_teams_table_row_label5: 'Work organization',
  productivity_teams_table_row_label6: 'Meetings',
  productivity_teams_table_row_label7: 'Trainings',
  productivity_teams_table_row_label8: 'Vacation',
  productivity_teams_table_row_label9: 'Absence',
  productivity_teams_table_row_label10: 'Early leave',
  productivity_teams_table_row_label11: 'SUM',
  productivity_teams_table_row_label12: 'Sick leave',
  productivity_teams_table_row_label13: 'Released from obligation to work',
  productivity_teams_table_rcp_label1: 'RCP Data',
  productivity_teams_table_rcp_label2: 'Working days',
  productivity_teams_table_rcp_label3: 'Full-time jobs',
  productivity_teams_table_rcp_label4: 'Working hours',
  productivity_teams_table_rcp_label5: 'Hours',
  productivity_teams_table_rcp_label6: 'Difference',
  perso_rcp_info: 'Tip: You can edit the RCP data table cells.',
  perso_teams_btn_qct: 'QC team',
  perso_teams_btn_indet: 'Content team',
  perso_teams_btn_devt: 'Development team',
  perso_teams_btn_loct: 'Localization team',
  perso_teams_btn_all: 'All teams',
  perso_teams_date: ' Personal Report for the ',
  perso_table_sum: 'SUMA:',
  perso_table_sum_absence_hours: 'SUMA NIEOBECNOŚCI (Godziny):',
  perso_table_sum_absence_days: 'SUMA NIEOBECNOŚCI (Dni):',
  admin_panel_nav_label1: 'Employees work plans',
  admin_panel_nav_label2: 'User management',
  admin_panel_nav_label3: 'Module management',
  admin_panel_nav_label4: 'Close admin panel',
  admin_panel_mod_mgmt_info:
    "*Remember that depending on the client's choice, some modules need to be added twice. For example, the HIL module for Logistics (client) must be added for Logistics and per Country for Logistics.",
  admin_panel_toast_detail: 'New module added: ',
  admin_panel_module_mgmt_header: 'Add New Module',
  admin_panel_label_client: 'Select Client:',
  admin_panel_placeholder_client: 'Select a client',
  admin_panel_label_mod_type: 'Select Module Type:',
  admin_panel_placeholder_mod_type: 'Select a module type',
  admin_panel_label_module: 'Module Name:',
  admin_panel_label_minor_proj: 'Minor project:',
  admin_panel_label_minor_info_label:
    'By clicking this button you will add a module to the Drobne_projekty list. This option is not obligatory if you only want to add a module to Others.',
  admin_panel_label_minor_info_label2:
    'Disclimer: As of the end of 09.2024, minor projects are no longer added. However, the option to add them remains.',
  admin_panel_placeholder_module: 'Write module name',
  admin_panel_info_module: 'Remember to use English for module names!',
  admin_panel_add_minor_proj_btn: 'Click here to add Drobne_projekty',
  admin_panel_add_minor_proj_back_btn: 'Back',
  admin_panel_add_module_btn: 'Add Module',
  admin_panel_export_info: 'The list of all modules in the database is available by clicking the export button.',
  admin_panel_user_mgmt_toast_detail: 'New user added: ',
  admin_panel_user_mgmt_toast_delete_detail: 'User removed: ',
  admin_panel_user_mgmt_toast_update_detail: 'User details updated: ',
  admin_panel_user_mgmt_role1: 'Administrator role',
  admin_panel_user_mgmt_role2: 'User role',
  admin_panel_user_mgmt_availability1: 'User available',
  admin_panel_user_mgmt_availability2: 'User not available',
  admin_panel_user_mgmt_header: 'User Management',
  admin_panel_user_mgmt_dialog_header: ' details',
  admin_panel_user_mgmt_dialog_hours: 'User Working Hours:',
  admin_panel_user_mgmt_dialog_hours_info: 'Select whether the employee is full-time (normal) or 7-hour (special).',
  admin_panel_user_mgmt_dialog_team: 'Team:',
  admin_panel_user_mgmt_dialog_team_placeholder: 'Select team',
  admin_panel_user_mgmt_dialog_admin: 'Admin role:',
  admin_panel_user_mgmt_dialog_admin_placeholder: 'Select role',
  admin_panel_user_mgmt_dialog_availability: 'Availability:',
  admin_panel_user_mgmt_dialog_availability_placeholder: 'Select availability',
  admin_panel_user_mgmt_dialog_delete_header: 'Delete user: ',
  admin_panel_user_mgmt_dialog_delete_info1:
    'Attention! You are trying to delete a user. The process is irreversible. Enter username ',
  admin_panel_user_mgmt_dialog_delete_info2: ' to remove it.',
  admin_panel_user_mgmt_dialog_delete_placeholder: 'Write user name',
  admin_panel_user_mgmt_dialog_delete_btn: 'Remove',
  admin_panel_user_mgmt_list_title: 'List of ELD users:',
  admin_panel_user_mgmt_form_title: 'Add New User',
  admin_panel_user_mgmt_form_name: 'User Name:',
  admin_panel_user_mgmt_form_name_info: 'For last name, enter only initials! e.g Joe D.',
  admin_panel_user_mgmt_form_name_placeholder: 'Write user name',
  admin_panel_user_mgmt_form_hours: 'User Working Hours:',
  admin_panel_user_mgmt_form_hours_info: 'Select whether the employee is full-time (normal) or 7-hour (special).',
  admin_panel_user_mgmt_form_hours_placeholder: 'Select working hours',
  admin_panel_user_mgmt_form_submmit: 'Add User',
  admin_panel_plan_header: 'Employees work plans',
  admin_panel_plan_btn_title_all: 'All employees',
  admin_panel_plan_btn_subtitle: 'Work plan',
  admin_panel_plan_btn_title_cont: 'Content Team',
  admin_panel_plan_btn_title_dev: 'Development Team',
  admin_panel_plan_btn_title_loc: 'Localization Team',
  admin_panel_plan_btn_title_qc: 'Quality Control Team',
  admin_panel_plan_btn_title_free: 'Junior Experts and Expert',
  admin_panel_plan_btn_compressed_view: 'Team Compressed view',
  admin_panel_plan_btn_compressed_view_hide: 'Hide Team Compressed view',
  admin_work_plan_compressed_day: 'Day',
  admin_work_plan_compressed_wh: 'Work hours',
  admin_work_plan_compressed_wpl: 'Work place',
  admin_work_plan_compressed_task: 'Task',
  admin_table_cw: 'Select CW:',
  admin_table_year: 'Select year:',
  admin_panel_plan_detail_table_th1: 'Day',
  admin_panel_plan_detail_table_th2: 'Work hours',
  admin_panel_plan_detail_table_th3: 'Reported hours',
  admin_panel_plan_detail_table_th4: 'Work place',
  admin_panel_plan_detail_table_th5: 'Client',
  admin_panel_plan_detail_table_th6: 'Country',
  admin_panel_plan_detail_table_th7: 'Task',
  admin_panel_plan_detail_table_th8: 'Stage',
  admin_panel_plan_detail_table_th9: 'Module hours',
  admin_panel_plan_detail_table_th10: 'Comment',
  admin_chart_label1: 'Date: ',
  admin_chart_label2: 'Available desks: ',
  admin_chart_label3: 'All desks: ',
  user_logs_btn_post_table: 'Post table',
  user_logs_btn_esp_table: 'ESP table',
  user_logs_btn_esp_table_access: 'ESP access',
  user_logs_btn_esp_table_access_info: 'Limited access table.',
  user_logs_table_tabkeys_header: 'Tab keys',
  user_logs_table_btn_label_expand: 'Expand All',
  user_logs_table_btn_label_collapse: 'Collapse All',
  user_logs_table_dialog_client: 'Client is missing, please select it from the list.',
  user_logs_table_dialog_client_btn_label1: 'ELD',
  user_logs_table_dialog_client_btn_label2: 'INT',
  user_logs_table_dialog_client_btn_label3: 'Countries',
  user_logs_table_dialog_client_btn_label4: 'Logistics',
  user_logs_table_dialog_client_btn_label5: 'Other',
  user_logs_table_absence: 'ABSENCE',
  user_logs_table_month_counter1: 'There are ',
  user_logs_table_month_counter2: ' days left until the end of the month.',
  user_logs_table_no_posts: 'No user entries, plan your week in Work Planner.',
  mobile_overlay_info: 'The application is not available on mobile devices.',
  logout_btn_label: 'Log out',
  widget_title: 'Releases',
  widget_bug_1: 'Have you noticed a ',
  widget_bug_2: 'bug',
  widget_bug_3: '? Report it directly on ',
  widget_bug_4: 'JIRA',
  widget_bug_5: ' sub-task by clicking:',
  widget_bug_report: 'Report bug',
  widget_bug_report_info:
    'Remember to describe the error as best as possible. Include screenshots if you think they are needed.',
  widget_fields: 'Fill in the fields: ',
  widget_field_1: 'Summary',
  widget_field_2: 'Description',
  widget_field_3: 'Attachment',
  widget_field_4: 'Issue',
  widget_field_5: 'Assignee',
  widget_assign: ' Assign the task to the person responsible for the project.',
  logout_info: 'User logged out.',
  currency: '€',
  currency_zl: 'zł',
  esp_price_list_btn: 'Price List',
  esp_price_list_title: 'ESP Services Price List',
  esp_price_list_empty: 'No data to display',
  esp_price_list_col_module: 'Module',
  esp_price_list_col_llidero: 'LLidero',
  esp_price_list_col_eld2: 'from ELD 2',
  esp_price_list_col_second_lang: 'SECOND LANGUAGE',
  esp_price_list_col_welearning: 'WeLearning',
  esp_price_list_col_welearning_eld2: 'from ELD 2',
  esp_more_filters: 'More Filters',
  esp_sign_off_stage_filter: 'Sign off stage filter',
  esp_sign_off_stage_filter_clear: 'Clear Sign off filter',
  esp_date_range_filter: 'Date range filter',
  esp_date_range_filter_clear: 'Clear Date range filter',
  esp_invoice_date_filter: 'Invoice Date filter',
  esp_invoice_date_filter_clear: 'Clear Invoice Date filter',
  esp_invoice_date_filter_header: 'Select Invoice Date Range',
  esp_provide_content_filter: 'Provide content filter',
  esp_provide_content_filter_clear: 'Clear Provide content filter',
  esp_settlements_report_col_id: 'Lp.',
  esp_settlements_report_col_gj: 'GJ',
  esp_settlements_report_col_esp: 'ESP',
  esp_settlements_report_col_country: 'Country',
  esp_settlements_report_col_module: 'Module',
  esp_settlements_report_col_mod_type: 'Module type',
  esp_settlements_report_col_lang: 'Language',
  esp_settlements_report_col_version: 'Version',
  esp_settlements_report_col_inv_type: 'First or second invoice',
  esp_settlements_report_col_date_reg: 'Invoice Date',
  esp_settlements_report_col_net_paid: 'Net paid invoice',
  esp_settlements_report_col_net_paid_eur: 'Net paid EUR Invoice',
  esp_settlements_report_col_gross_paid: 'Gross paid Invoice',
  esp_settlements_report_col_gross_paid_eur: 'Gross paid EUR Invoice',
  esp_settlements_report_col_inv_num: 'Invoice number',
  esp_settlements_report_col_date_conf: 'Payment Date',

esp_price_list_data: [
    { module: 'FTF 2.0', secondLanguage: '-8%', isCategory: true },
    { module: 'ASMA', llidero: '4 600,00 PLN', eld2: '', secondLanguage: '', welearning: '4000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'AUDI', llidero: '11 266,00 PLN', eld2: '', secondLanguage: '', welearning: '9000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'BAKE', llidero: '9 976,00 PLN', eld2: '8 180 PLN', secondLanguage: '', welearning: '7800', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'CAND', llidero: '8800', eld2: '7216', secondLanguage: '', welearning: '8200', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'CASH1', llidero: '5952', eld2: '', secondLanguage: '', welearning: '5800', welearningEld2: '', boldFields: [] },
    { module: 'CASH2', llidero: '8928', eld2: '', secondLanguage: '', welearning: '5700', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'DUTY', llidero: '4902', eld2: '4020', secondLanguage: '', welearning: '5600', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'EASM', llidero: '10382', eld2: '8513', secondLanguage: '', welearning: '7600', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'IMSM', llidero: '13008', eld2: '10667', secondLanguage: '', welearning: '8300', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'INVM1', llidero: '6751', eld2: '5536', secondLanguage: '', welearning: '7400', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'INVM2', llidero: '11985', eld2: '9 828 PLN', secondLanguage: '', welearning: '8000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'MACO', llidero: '7920', eld2: '6 495 PLN', secondLanguage: '', welearning: '5290', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'MEIN', llidero: '8304', eld2: '', secondLanguage: '', welearning: '8200', welearningEld2: '', boldFields: [] },
    { module: 'SACO', llidero: '9 933,00 PLN', eld2: '8 145 PLN', secondLanguage: '', welearning: '7600', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'WOSA', llidero: '10 150,00 PLN', eld2: '8323', secondLanguage: '', welearning: '7700', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'WOSC', llidero: '10 830,00 PLN', eld2: '', secondLanguage: '', welearning: '6800', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LEYS', llidero: '4500', eld2: '', secondLanguage: '', welearning: '4000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'PEST', llidero: '11100', eld2: '', secondLanguage: '', welearning: '7900', welearningEld2: '', boldFields: ['welearning'] },

    { module: 'MA 3.0', isCategory: true },
    { module: 'AKG1', llidero: '6240', eld2: '', secondLanguage: '', welearning: '7000', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'AKG2', llidero: '8800', eld2: '', secondLanguage: '', welearning: '6100', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'BOF', llidero: '5520', eld2: '', secondLanguage: '', welearning: '7000', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'FMQ', llidero: '5904', eld2: '4413,24', secondLanguage: '', welearning: '5000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'OGB', llidero: '3744', eld2: '2798,64', secondLanguage: '', welearning: '5100', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'WVR', llidero: '4320', eld2: '3229,2', secondLanguage: '', welearning: '3780', welearningEld2: '4700', boldFields: ['llidero'] },
    { module: 'FLK', llidero: '4400', eld2: '', secondLanguage: '', welearning: '1600', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LIP', llidero: '5280', eld2: '3946,8', secondLanguage: '', welearning: '2700', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'KVH', llidero: '7280', eld2: '5441,8', secondLanguage: '', welearning: '7800', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'KLK', llidero: '5600', eld2: '4186', secondLanguage: '', welearning: '6000', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'CPS', llidero: '6240', eld2: '4664,4', secondLanguage: '', welearning: '5460', welearningEld2: '3850', boldFields: ['welearning'] },
    { module: '4PF', llidero: '5360', eld2: '4006,6', secondLanguage: '', welearning: '3500', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'EAS', llidero: '5120', eld2: '3827,2', secondLanguage: '', welearning: '4800', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'ESL', llidero: '3858,4', eld2: '', secondLanguage: '', welearning: '3100', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'INV', llidero: '4769,6', eld2: '', secondLanguage: '', welearning: '7400', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'HUS', llidero: '6094,5', eld2: '', secondLanguage: '', welearning: '7500', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'SUF', llidero: '4993,6', eld2: '3732', secondLanguage: '', welearning: '6600', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'EFI', llidero: '3600', eld2: '1700', secondLanguage: '', welearning: '1500', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'ENM', llidero: '3996', eld2: '2900', secondLanguage: '', welearning: '2600', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'PES', llidero: '3772', eld2: '3300,5', secondLanguage: '', welearning: '2800', welearningEld2: '', boldFields: ['welearning'] },

    { module: 'LOGISTICS', isCategory: true },
    { module: 'SUL', llidero: '4 800,00 PLN', eld2: '3936', secondLanguage: '-', welearning: '', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'WEM', llidero: '5 828,00 PLN', eld2: '4 779 PLN', secondLanguage: '', welearning: '3470', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LENM', llidero: '6600', eld2: '5412', secondLanguage: '', welearning: '3900', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'PEP-L', llidero: '7000', eld2: '5740', secondLanguage: '-', welearning: '', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'HIL', llidero: '4560', eld2: '3408,6', secondLanguage: '', welearning: '2400', welearningEld2: '1950', boldFields: ['welearning'] },
    { module: 'LREC', llidero: '7900', eld2: '6478', secondLanguage: '', welearning: '5800', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LWOTR', llidero: '4950', eld2: '', secondLanguage: '-', welearning: '', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'FAV', llidero: '4801', eld2: '', secondLanguage: '', welearning: '3500', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'KOL/EKOL', llidero: '6200', eld2: '', secondLanguage: '', welearning: '7000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'DOCIT', llidero: '4909', eld2: '', secondLanguage: '-', welearning: '', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'MTEL', llidero: '4187,4', eld2: '', secondLanguage: '', welearning: '3000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'RHT', llidero: '3927,2', eld2: '2935,58', secondLanguage: '', welearning: '4200', welearningEld2: '', boldFields: [] },
    { module: 'KBA_N_PCM', llidero: '3520', eld2: '', secondLanguage: '', welearning: '2000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'KBA_N_TCM', llidero: '3608', eld2: '', secondLanguage: '', welearning: '2200', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'KBA_N_MCM', llidero: '3600', eld2: '', secondLanguage: '', welearning: '2200', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'KBA_N_DCM', llidero: '3624', eld2: '', secondLanguage: '', welearning: '2700', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LSACO GOODS in', llidero: 'First module in series: 5210\nSubsequent ones: -12%', eld2: '', secondLanguage: '', welearning: '4100', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LSACO PICKER', llidero: 'First module in series: 5038\nSubsequent ones: -12%', eld2: '', secondLanguage: '', welearning: '3500', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LSACO SELECTION OFFICE', llidero: 'First module in series: 4973\nSubsequent ones: -12%', eld2: '', secondLanguage: '', welearning: '3200', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LSACO CHECKER', llidero: 'First module in series: 5726\nSubsequent ones: -12%', eld2: '', secondLanguage: '', welearning: '5200', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LSACO TRANSPORT', llidero: 'First module in series: 5962\nSubsequent ones: -12%', eld2: '', secondLanguage: '', welearning: '6300', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'LSACO GENERAL', llidero: 'First module in series: 3500\nSubsequent ones: -12%', eld2: '', secondLanguage: '', welearning: '1500', welearningEld2: '', boldFields: ['welearning'] },

    { module: 'OTHER', isCategory: true },
    { module: 'ARIS', llidero: '5050', eld2: '', secondLanguage: '', welearning: '3600', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'EXMA', llidero: '1900', eld2: '', secondLanguage: '', welearning: '2400', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'KPI_N', llidero: '2350', eld2: '', secondLanguage: '', welearning: '3400', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'SCO', llidero: '8855', eld2: '7 261 PLN', secondLanguage: '', welearning: '7200', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'CSR', llidero: '3960', eld2: '', secondLanguage: '', welearning: '3996', welearningEld2: '', boldFields: [] },
    { module: 'BUDDY/BUDDY LOG/BUDDY HQ', llidero: '3806,4', eld2: '3092,7', secondLanguage: '', welearning: '3000', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'ABF', llidero: '4202,4', eld2: '3414,4', secondLanguage: '', welearning: '4800', welearningEld2: '', boldFields: ['llidero'] },
    { module: 'BOA', llidero: '3960', eld2: '', secondLanguage: '', welearning: '2600', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'ONBOARDING', llidero: '3961,6', eld2: '', secondLanguage: '', welearning: '3800', welearningEld2: '', boldFields: ['welearning'] },
    { module: 'LOS', llidero: '3200', eld2: '1 round of corrections', secondLanguage: '', welearning: '', welearningEld2: '', boldFields: ['welearning'] }
  ],
};